import { render } from "./Portfolio.vue?vue&type=template&id=78fc9e9a&scoped=true"
import script from "./Portfolio.vue?vue&type=script&lang=js"
export * from "./Portfolio.vue?vue&type=script&lang=js"

import "./Portfolio.vue?vue&type=style&index=0&id=78fc9e9a&scoped=true&lang=css"

import exportComponent from "F:\\PROJECTS\\2022\\webagent.ir\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78fc9e9a"]])

export default __exports__